module.exports = __webpack_public_path__ + "static/media/info03_L.79fdc4ef.png";